// extracted by mini-css-extract-plugin
module.exports = {"meBackgroundPatternVintage":"PrimaryFeatures_meBackgroundPatternVintage__fjW2B"};